export const TEAM = ['Bob', 'Ray', 'Adam', 'Diana'];

export const STATUSES = ['Action Required', 'In Progress', 'Pending Response', 'Complete'];

export const PRIORITIES = ['High', 'Medium', 'Low'];

export const STATUS_META = {
  'Action Required': { color: '#ef4444', bg: '#fef2f2', icon: '🔴' },
  'In Progress':     { color: '#3b82f6', bg: '#eff6ff', icon: '🔵' },
  'Pending Response':{ color: '#f59e0b', bg: '#fffbeb', icon: '🟡' },
  'Complete':        { color: '#22c55e', bg: '#f0fdf4', icon: '✅' },
};

export const PRIORITY_COLOR = { High: '#dc2626', Medium: '#d97706', Low: '#6b7280' };
export const PRIORITY_DOT   = { High: '#dc2626', Medium: '#d97706', Low: '#9ca3af' };

export const PASSWORD  = '4!2Pittsburgh';
export const AUTH_KEY  = 'snp_auth_v1';
export const USER_KEY  = 'snp_user_v1';

export function today() {
  return new Date().toISOString().split('T')[0];
}

export function nowISO() {
  return new Date().toISOString().slice(0, 16);
}

export function fmtDate(iso) {
  if (!iso) return '—';
  const [y, m, d] = iso.split('-');
  return `${m}/${d}/${y}`;
}

export function getWeekStart(date) {
  const d = new Date(date);
  const day = d.getDay();
  d.setDate(d.getDate() - day + (day === 0 ? -6 : 1));
  return d.toISOString().split('T')[0];
}

export function getWeekEnd(ws) {
  const d = new Date(ws);
  d.setDate(d.getDate() + 6);
  return d.toISOString().split('T')[0];
}

export function linkify(text) {
  if (!text) return '';
  return text.replace(/(https?:\/\/[^\s]+)/g, (url) =>
    `<a href="${url}" target="_blank" rel="noopener noreferrer" style="color:#3b82f6;text-decoration:underline;word-break:break-all">${url}</a>`
  );
}

export function generateTimeOptions() {
  const options = [];
  for (let h = 0; h < 24; h++) {
    for (let m of [0, 15, 30, 45]) {
      const hour12 = h % 12 || 12;
      const ampm = h < 12 ? 'AM' : 'PM';
      const label = `${hour12}:${String(m).padStart(2, '0')} ${ampm}`;
      const value = `${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}`;
      options.push({ label, value });
    }
  }
  return options;
}

export function formatTime(t) {
  if (!t) return '';
  const [h, m] = t.split(':');
  const hour = parseInt(h);
  const ampm = hour < 12 ? 'AM' : 'PM';
  return `${hour % 12 || 12}:${m} ${ampm}`;
}

export const SEED_TASKS = [
  { id: 1, title: 'Dreamcatcher 2 Controller — Screen Goes White', assignees: ['Bob'], status: 'In Progress', priority: 'High', notes: 'Screen goes white periodically; reboot of controller solves short-term.', nextSteps: 'Await response from Kevin at Evertz.', completionNote: '', dateAdded: '2026-05-02', dateUpdated: null, dateResolved: null, completedBy: '' },
  { id: 2, title: 'Unity Mac Crashing', assignees: ['Bob'], status: 'In Progress', priority: 'High', notes: 'Crashed twice during Pirates game. Planning ETH swap to Juniper switch.', nextSteps: 'Swap ETH to Juniper; source USB-C NIC.', completionNote: '', dateAdded: '2026-05-02', dateUpdated: null, dateResolved: null, completedBy: '' },
  { id: 4, title: 'DA 21 Bad (46)', assignees: ['Ray'], status: 'Action Required', priority: 'High', notes: 'Need to determine what is actually happening with DA 21.', nextSteps: 'Investigate DA 21 behavior.', completionNote: '', dateAdded: '2026-05-02', dateUpdated: null, dateResolved: null, completedBy: '' },
  { id: 5, title: 'DA 49 & 50 Wiring', assignees: ['Ray'], status: 'Action Required', priority: 'High', notes: 'Bob mentioned wiring seems off. Need to investigate.', nextSteps: 'Trace and verify wiring.', completionNote: '', dateAdded: '2026-05-02', dateUpdated: null, dateResolved: null, completedBy: '' },
  { id: 16, title: 'Joseph TX/RX Modules — PPG Paints Arena', assignees: ['Ray'], status: 'Pending Response', priority: 'High', notes: 'Known bad JFS pathways per Doug S.', nextSteps: 'Schedule maintenance day at PPG with Doug S.', completionNote: '', dateAdded: '2026-05-02', dateUpdated: null, dateResolved: null, completedBy: '' },
];
